module.exports = __webpack_public_path__ + "img/NL341.5117bde3.png";